import { PetrusError, PetrusErrorType } from '../../../config';
import { isFn } from '../../../services/utils';
import { config as refreshmentConfig } from "../modules/refreshment";
export const handlers = ({
  refreshTokens
}) => {
  if (!isFn(refreshTokens)) {
    throw new PetrusError(PetrusErrorType.INVALID_REFRESH_TOKENS_HANDLER, `'refreshTokens' is not a function: Received argument: ${refreshTokens}.`);
  }

  return {
    refreshTokens
  };
};
export const options = customOptions => ({
  autoStartTokensRetrieval: true,
  ...refreshmentConfig.options,
  ...customOptions
});